module.exports = __webpack_public_path__ + "media/images/pages/tasks/guide-2d66bf474ffc052e907a8471ed98eea5.png";